export default {
  setClients(state, payload) {
    state.clients = payload;
  },
};
